import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "invalid-token",
    templateUrl: "./invalid-token.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvalidTokenComponent {}